// extracted by mini-css-extract-plugin
module.exports = {"mobile":"0","tablet":"768","desktop":"1366"};